export default function getDeadlineDisplayName(
  deadline,
  isCommonAppDeadlinesFlagOn = false,
) {
  const { type, description, term } = deadline;

  let displayName = type.trim();

  if (type === 'Other' && description && description.trim() !== '') {
    displayName = description.trim();
  }

  if (!displayName.toLowerCase().includes('deadline')) {
    displayName = `${displayName} Deadline`;
  }

  if (isCommonAppDeadlinesFlagOn && term) return `${term} - ${displayName}`;
  return displayName;
}

export function getDeadlineTerm(deadline) {
  let { term } = deadline;

  if (!term) return '';

  term = term.trim();

  // Add suffix of 'Term' if not already present
  if (!term.toLowerCase().includes('term')) {
    term = term + ' Term';
  }

  return term;
}
